module.exports = __webpack_public_path__ + "img/gift-06-c1.a8c1904a.png";